import { render, staticRenderFns } from "./PerformanceScatterChart.vue?vue&type=template&id=3ef473b0"
import script from "./PerformanceScatterChart.vue?vue&type=script&lang=js"
export * from "./PerformanceScatterChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports